import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, PenTool, Sparkles } from 'lucide-react';
export function WhySection() {
  return <section className="py-24 px-4 bg-[#FDF8F3] relative overflow-hidden" data-id="element-158">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-white rounded-full blur-3xl opacity-60 pointer-events-none" data-id="element-159" />

      <div className="container max-w-4xl mx-auto relative z-10 text-center" data-id="element-160">
        <FadeIn data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3D3229] mb-8" data-id="element-162">
            ¿Por qué esto no es otro diario más?
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-163">
          <p className="text-xl text-[#3D3229]/80 leading-relaxed mb-12 max-w-3xl mx-auto" data-id="element-164">
            A diferencia de otras soluciones, este kit fue diseñado para gente
            que necesita resultados rápidos y prácticos. No te va a pedir que
            escribas páginas enteras ni que medites por horas. Solo necesitás 5
            minutos: un audio corto, 3 preguntas y listo.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mt-16" data-id="element-165">
          <FadeIn delay={0.3} className="flex flex-col items-center" data-id="element-166">
            <div className="w-16 h-16 bg-[#C4703F]/10 rounded-2xl flex items-center justify-center text-[#C4703F] mb-4" data-id="element-167">
              <Clock className="w-8 h-8" data-id="element-168" />
            </div>
            <h3 className="font-serif font-bold text-lg mb-2" data-id="element-169">Rápido</h3>
            <p className="text-[#3D3229]/70" data-id="element-170">Solo 5 minutos al día</p>
          </FadeIn>

          <FadeIn delay={0.4} className="flex flex-col items-center" data-id="element-171">
            <div className="w-16 h-16 bg-[#8B9E7E]/10 rounded-2xl flex items-center justify-center text-[#8B9E7E] mb-4" data-id="element-172">
              <PenTool className="w-8 h-8" data-id="element-173" />
            </div>
            <h3 className="font-serif font-bold text-lg mb-2" data-id="element-174">Práctico</h3>
            <p className="text-[#3D3229]/70" data-id="element-175">Sin teorías complejas</p>
          </FadeIn>

          <FadeIn delay={0.5} className="flex flex-col items-center" data-id="element-176">
            <div className="w-16 h-16 bg-[#3D3229]/5 rounded-2xl flex items-center justify-center text-[#3D3229] mb-4" data-id="element-177">
              <Sparkles className="w-8 h-8" data-id="element-178" />
            </div>
            <h3 className="font-serif font-bold text-lg mb-2" data-id="element-179">Efectivo</h3>
            <p className="text-[#3D3229]/70" data-id="element-180">Resultados en 7 días</p>
          </FadeIn>
        </div>
      </div>
    </section>;
}